import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userLoginDetails: {
    given_name: "",
    email: "",
    user_type: "",
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserLoginDetails: (state, action) => {
      const payload = action.payload;
      for (const key in payload) {
        state.userLoginDetails[key] = payload[key];
      }
    },
  },
});

export const { setUserLoginDetails } = authSlice.actions;
export default authSlice.reducer;
